module.exports = __webpack_public_path__ + "static/media/contact.586b9657.jpg";